import React, { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext'; // Only if needed for success nav logic
import Toast from './Toast';
import '../pages/Login.css'; // Reuse login styles
import './LoginModal.css';

const LoginModal = ({ onClose, onSuccess }) => {
  const [step, setStep] = useState('phone'); // 'phone' or 'otp'
  const [phone, setPhone] = useState('');
  const [otp, setOtp] = useState('');
  const [isProcessing, setIsProcessing] = useState(false);
  const [toast, setToast] = useState(null);
  const [timer, setTimer] = useState(0);

  // Timer for OTP
  useEffect(() => {
    let interval;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const showNotification = (message, type = 'success') => {
    setToast({ message, type });
  };
  const handleCloseToast = () => setToast(null);

  const sendOTP = async () => {
    if (!/^\d{10}$/.test(phone)) {
      showNotification('Please enter a valid 10-digit phone number', 'error');
      return;
    }
    setIsProcessing(true);
    try {
      const response = await fetch('https://panel.supplebakes.com/order/send-otp.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone })
      });
      const data = await response.json();
      if (data.success) {
        setStep('otp');
        setTimer(30);
        setIsProcessing(false);
        showNotification('OTP sent successfully!');
      } else {
        setIsProcessing(false);
        showNotification(data.message || 'Failed to send OTP', 'error');
      }
    } catch (error) {
      setIsProcessing(false);
      showNotification('Network error.', 'error');
    }
  };

  const verifyOTP = async () => {
    if (otp.length !== 6) {
      showNotification('Please enter a valid OTP', 'error');
      return;
    }
    setIsProcessing(true);
    try {
      const response = await fetch('https://panel.supplebakes.com/order/verify-otp.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone: phone, otp: otp })
      });
      const data = await response.json();
      if (data.success) {
        localStorage.setItem('user_phone', phone);
        if (onSuccess) onSuccess();
        onClose(); // Close modal on success
      } else {
        showNotification(data.message || 'Invalid OTP', 'error');
        setIsProcessing(false);
      }
    } catch (error) {
      showNotification('Verification failed.', 'error');
      setIsProcessing(false);
    }
  };

  return (
    <div className="login-modal-overlay" onClick={onClose}>
      <div className="login-modal-content glass-effect slide-up" onClick={e => e.stopPropagation()}>
        <button className="modal-close-btn" onClick={onClose}>&times;</button>
        <div className="login-header">
          <h2 className="login-title">Login</h2>
          <p className="login-subtitle">Login to save your favorites</p>
        </div>

        <div className="login-form">
          {step === 'phone' ? (
            <div className="form-group">
              <label className="form-label">Phone Number</label>
              <div className="phone-input-wrapper">
                <span className="country-code">+91</span>
                <input
                  type="tel"
                  className="form-input phone-input"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
                  placeholder="Enter 10 digit number"
                  maxLength="10"
                />
              </div>
              <button 
                className="submit-btn btn-primary ripple" 
                onClick={sendOTP}
                disabled={isProcessing || phone.length < 10}
              >
                {isProcessing ? 'Sending...' : 'Get OTP'}
              </button>
            </div>
          ) : (
            <div className="form-group">
              <label className="form-label">Enter OTP</label>
              <input
                type="text"
                className="form-input otp-input"
                value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
                placeholder="------"
                maxLength="6"
              />
              <div className="otp-actions">
                <button 
                  className="resend-btn" 
                  onClick={sendOTP} 
                  disabled={timer > 0 || isProcessing}
                >
                  {timer > 0 ? `Resend in ${timer}s` : 'Resend OTP'}
                </button>
              </div>
              <button 
                className="submit-btn btn-primary ripple" 
                onClick={verifyOTP}
                disabled={otp.length < 6}
              >
                Verify & Login
              </button>
            </div>
          )}
        </div>
        {toast && <Toast message={toast.message} type={toast.type} onClose={handleCloseToast} />}
      </div>
    </div>
  );
};

export default LoginModal;
